module.exports = __webpack_public_path__ + "static/media/layer-group.97b52a36.svg";